import validate from 'validate.js'

validate.formatters.custom = function (errors) {
  return errors.length > 0 ? errors[0].error : false
}

export default validate



// WEBPACK FOOTER //
// ./src/Config/Validator.js